import {
  ADD_PARTICIPANT,
  REMOVE_PARTICIPANT,
  REMOVE_LOOK_PARTICIPANTS,
  UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS,
  UPDATE_CURRENT_PEOPLE,
} from '../actions/people'

import {GET_EVENT_LOOKS_SUCCESS} from '../actions/api'

import {CLEAR_CURRENT_EVENT, CREATE_NEW_EVENT} from '../actions/events'

function getParticipantLookIndex(participants, newParticipant) {
  const {lookId} = newParticipant
  function matchesLookId(participant) {
    return participant.lookId === lookId
  }
  return participants.findIndex(matchesLookId)
}

const initialState = {
  participants: [],
  user: [],
}

export default function reducer(state = initialState, action) {
  let newState
  let index
  let newArray
  let wearerToRemove
  let participantToRemove
  let removeLastWearer
  let removedArray

  switch (action.type) {
    case ADD_PARTICIPANT:
      index = getParticipantLookIndex(state.participants, action.newParticipant)
      if (index === -1) {
        // participant added to new look
        newArray = [...state.participants, action.newParticipant]
      } else {
        // participant added to existing look
        newArray = state.participants.map((participant) => {
          if (participant.lookId !== action.newParticipant.lookId) {
            return participant
          }
          return {
            ...participant,
            wearers: [...participant.wearers, ...action.newParticipant.wearers],
          }
        })
      }
      newState = {participants: newArray}
      break
    case CLEAR_CURRENT_EVENT:
      // clear current event people
      newState = {
        participants: [],
        user: [],
      }
      break
    case CREATE_NEW_EVENT:
      newState = {
        participants: [],
        user: [],
      }
      break
    case GET_EVENT_LOOKS_SUCCESS:
      newState = action.payload.people
      break
    case REMOVE_PARTICIPANT:
      state.participants.forEach(({wearers}, participantIndex) => {
        const wearerIndex = wearers.findIndex(
          ({userEventLookId}) => action.participantId === userEventLookId,
        )
        if (wearerIndex !== -1) {
          participantToRemove = participantIndex
          wearerToRemove = wearerIndex
          if (wearers.length === 1) {
            removeLastWearer = true
          }
        }
      })

      if (removeLastWearer === true) {
        removedArray = [
          ...state.participants.slice(0, participantToRemove),
          ...state.participants.slice(participantToRemove + 1),
        ]
      } else {
        removedArray = state.participants.map((participant, participantIndex) => {
          if (participantIndex !== participantToRemove) {
            return participant
          }
          return {
            ...participant,
            wearers: [
              ...participant.wearers.slice(0, wearerToRemove),
              ...participant.wearers.slice(wearerToRemove + 1),
            ],
          }
        })
      }
      newState = {participants: removedArray}
      break
    case REMOVE_LOOK_PARTICIPANTS:
      newState = {
        participants: state.participants.filter((person) => person.lookId !== action.lookId),
        user: state.user.filter((lookId) => lookId !== action.lookId),
      }
      break
    case UPDATE_IS_OWNER_WEARING_LOOK_SUCCESS: {
      const {isOwnerWearingLook, lookId} = action.payload

      if (isOwnerWearingLook) {
        newState = {user: [...state.user, lookId]}
      } else if (state.user.includes(lookId)) {
        newState = {user: state.user.filter((id) => lookId !== id)}
      } else {
        console.warn(`User is not assigned to ${lookId}, cannot remove`)
      }
      break
    }
    case UPDATE_CURRENT_PEOPLE:
      newState = action.payload
      break
    default: {
      break
    }
  }

  return newState ? Object.assign({}, state, newState) : state
}
